import { Box, Button } from "@mui/material";
import { StyledCalandar } from "./Calandar.styled";

export const Calandar = () => {
  return (
    <StyledCalandar>
      <Box className="header">
        <Button>Vandaag</Button>
      </Box>
    </StyledCalandar>
  );
};
